import { AppIconButton } from "../../global/ui/buttons";
import { ShareOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { invokeMobileShareDialog } from "../../../lib/global/invokeMobileShareDialog";
import getConfig from "next/config";
import { IGetConfig } from "../../../interfaces/next/IGetConfig";
import { buildUrlName } from "../../../lib/generic";
import { Listing } from "../../../interfaces/training-plan/Listing";

const { publicRuntimeConfig } = getConfig() as {
  publicRuntimeConfig: IGetConfig;
};

type BlogShareProps = {
  blog: Listing;
};

export const BlogShare = ({ blog }: BlogShareProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  const shareModalHandler = () => {
    invokeMobileShareDialog({
      title: `Pod1um Blog`,
      text: `Here's a blog from Pod1um`,
      url: `${publicRuntimeConfig.NEXT_PUBLIC_BASE_URL}/blog/${blog.id}/${buildUrlName(blog.title)}`,
    });
  };

  return (
    <AppIconButton onClick={shareModalHandler}>
      <ShareOutlined
        sx={{
          color: colors.surface.onSurface,
        }}
      />
    </AppIconButton>
  );
};
